/* REWAY VINTAGE - portal-gedrag
   Hover op het Vintage-tab: ivoor-iris vloeit vanuit het tab over de pagina (tease).
   Klik: iris sluit zich volledig (commit) en navigeert naar de vintage-wereld.
   Op de vintage-pagina: omgekeerde iris als entree.
   Event-delegatie op document zodat theme-editor section-rerenders het gedrag
   niet breken. */
(function () {
  var d = document;
  var root = d.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  /* de hele wereld telt: /pages/vintage en de vintage-collectiepagina's */
  var onVintagePage = d.body && d.body.className.indexOf('vintage') > -1;
  var VT_URL = '/pages/vintage';

  var openTimer = null;
  var closeTimer = null;
  var navTimer = null;
  var committed = false;

  /* ---- entree op de vintage-pagina (vlag gezet bij commit) ---- */
  if (root.classList.contains('rw-vt-enter')) {
    try { sessionStorage.removeItem('rwVtEnter'); } catch (e) {}
    if (reduced) {
      root.classList.remove('rw-vt-enter');
    } else {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('rw-vt-enter-go');
          setTimeout(function () {
            root.classList.remove('rw-vt-enter', 'rw-vt-enter-go');
          }, 1150);
        });
      });
    }
  }

  /* ---- bfcache: terugknop herstelt de pagina inclusief oude klassen ---- */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      committed = false;
      root.classList.remove('rw-vt-tease', 'rw-vt-commit', 'rw-vt-enter', 'rw-vt-enter-go');
      try { sessionStorage.removeItem('rwVtEnter'); } catch (err) {}
    }
  });
  /* concurrerende navigatie wint: geplande vintage-navigatie annuleren */
  window.addEventListener('pagehide', function () {
    if (navTimer) { clearTimeout(navTimer); navTimer = null; }
  });

  function setOrigin(x, y) {
    root.style.setProperty('--vt-x', Math.round(x) + 'px');
    root.style.setProperty('--vt-y', Math.round(y) + 'px');
  }

  function openTease(fromEl) {
    if (committed || onVintagePage || reduced || !canHover) return;
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (root.classList.contains('rw-vt-tease') || openTimer) return;
    /* korte intent-drempel: een muis die alleen langs het tab scheert opent niets */
    openTimer = setTimeout(function () {
      openTimer = null;
      if (committed) return;
      var r = fromEl.getBoundingClientRect();
      setOrigin(r.left + r.width / 2, r.top + r.height / 2);
      root.classList.add('rw-vt-tease');
    }, 110);
  }

  function keepOpen() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
  }

  function scheduleClose() {
    if (openTimer) { clearTimeout(openTimer); openTimer = null; }
    if (committed) return;
    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      root.classList.remove('rw-vt-tease');
    }, 170);
  }

  function commit(ev) {
    if (onVintagePage) return; /* al binnen: gewoon normaal navigeren */
    /* nieuw tabblad (Ctrl/Cmd/Shift/Alt-klik): browser zijn gang laten gaan */
    if (ev && (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button === 1)) return;
    if (committed) { if (ev) ev.preventDefault(); return; }
    committed = true;
    if (openTimer) { clearTimeout(openTimer); openTimer = null; }
    if (reduced) {
      /* geen animatie: vlag zetten en de link zelf laten navigeren */
      try { sessionStorage.setItem('rwVtEnter', '1'); } catch (e) {}
      return;
    }
    if (ev) ev.preventDefault();
    /* mobiele drawer staat boven de wash (z-index 95) - eerst sluiten */
    var drawer = d.getElementById('rw-drawer');
    if (drawer && !drawer.hidden) {
      drawer.hidden = true;
      d.body.style.overflow = '';
    }
    if (!root.classList.contains('rw-vt-tease') && ev && typeof ev.clientX === 'number' && ev.clientX > 0) {
      /* mobiel / geen tease actief: iris vanaf het tik-punt */
      setOrigin(ev.clientX, ev.clientY);
    }
    root.classList.remove('rw-vt-tease');
    root.classList.add('rw-vt-commit');
    navTimer = setTimeout(function () {
      try { sessionStorage.setItem('rwVtEnter', '1'); } catch (e) {}
      window.location.href = VT_URL;
    }, 600);
  }

  /* ---- event-delegatie ---- */
  d.addEventListener('mouseover', function (e) {
    if (!e.target || !e.target.closest) return;
    var tab = e.target.closest('[data-rw-vt-tab]');
    if (tab && tab.closest('.rw-catbar')) { openTease(tab); return; }
    if (e.target.closest('[data-rw-vt-wash]') && root.classList.contains('rw-vt-tease')) keepOpen();
  });

  d.addEventListener('mouseout', function (e) {
    if (!e.target || !e.target.closest) return;
    var from = e.target.closest('[data-rw-vt-tab], [data-rw-vt-wash]');
    if (!from) return;
    var to = e.relatedTarget && e.relatedTarget.closest
      ? e.relatedTarget.closest('[data-rw-vt-tab], [data-rw-vt-wash]')
      : null;
    if (!to) scheduleClose();
  });

  d.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var anchor = e.target.closest('a[href^="#vtl-"]');
    if (anchor) {
      var target = d.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
      }
      return;
    }
    if (e.target.closest('[data-rw-vt-tab]')) { commit(e); return; }
    if (e.target.closest('[data-rw-vt-wash]') && root.classList.contains('rw-vt-tease')) commit(e);
  });

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !committed) {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      root.classList.remove('rw-vt-tease');
    }
  });
})();
